import React from 'react';
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import { Navbar, Nav } from 'react-bootstrap'
import {
    Calendar3,
    PersonFill,
    BarChartFill,
    Book,
    PlusCircleFill
} from 'react-bootstrap-icons'
import NavIconLink from '../../common/nav-icon-link'
import { useLocation } from 'react-router-dom'
import hooks from '../../../hooks';

function Footer () {
    const { isTsc } = hooks.useCurrentUser()
    const location = useLocation().pathname
    return (
        <footer>
            <Navbar bg='primary' variant='dark' fixed="bottom">
                <Nav className='nav-fill w-100' activeKey={location} style={{ display: 'flex', justifyContent: 'space-around'}}>
                    {!isTsc &&
          <NavIconLink
              to={CLIENT_ENDPOINTS.SCHEDULE}
              icon={Calendar3}
              title='See your upcoming experiences'
          >
            SCHEDULE
          </NavIconLink>
                    }
                    {!isTsc &&
          <NavIconLink
              to={CLIENT_ENDPOINTS.PROFILE}
              icon={PersonFill}
              title='View your profile'
          >
            PROFILE
          </NavIconLink>
                    }
                    <NavIconLink
                        to={CLIENT_ENDPOINTS.CATALOG}
                        icon={!isTsc ? PlusCircleFill : Calendar3}
                        title='Register for additional experiences'
                    >
                        { isTsc ? 'EXPERIENCES' : 'ENROLL'}
                    </NavIconLink>
                    {!isTsc &&
          <NavIconLink
              to={CLIENT_ENDPOINTS.PROGRESS}
              icon={BarChartFill}
              title='View your progress'
          >
            PROGRESS
          </NavIconLink>
                    }
                    <NavIconLink
                        to={CLIENT_ENDPOINTS.LEARNING_RESOURCES}
                        icon={Book}
                        title='Additional learning resources'
                    >
            RESOURCES
                    </NavIconLink>
                </Nav>
            </Navbar>
        </footer>
    )
}

export default Footer
